var map = {
	"./0.jpg": 59,
	"./6.jpg": 60,
	"./baer.jpg": 61,
	"./blinkengel.gif": 62,
	"./boogg.jpg": 63,
	"./boogg_2.jpg": 64,
	"./busfahrer.jpg": 65,
	"./cello.jpg": 66,
	"./cidre.jpg": 67,
	"./eichhoerndli.jpg": 68,
	"./engel.jpg": 69,
	"./engel_drohne.png": 70,
	"./engel_engel.png": 71,
	"./engel_kugeln.png": 72,
	"./esel.jpg": 73,
	"./fabrikarbeiter.jpg": 74,
	"./fuchs.jpg": 75,
	"./fussball.jpg": 76,
	"./fussball_ball.png": 77,
	"./guezli.jpg": 78,
	"./guezli_guezli.png": 79,
	"./guezli_wasser.png": 80,
	"./kunsthaus.jpg": 81,
	"./laterne.jpg": 82,
	"./psychiater.jpg": 83,
	"./schwan.jpg": 84,
	"./seilbahn.jpg": 85,
	"./seilbahn_bahn.png": 86,
	"./seilbahn_sterne.png": 87,
	"./seilbahn_wand.png": 88,
	"./stern.gif": 89,
	"./surprise.jpg": 90,
	"./taube.jpg": 91,
	"./velo.jpg": 92,
	"./wage.jpg": 93,
	"./zwingli.gif": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58;